import { render, staticRenderFns } from "./addWeightAuditor.vue?vue&type=template&id=c6d796b6&scoped=true&"
import script from "./addWeightAuditor.vue?vue&type=script&lang=js&"
export * from "./addWeightAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d796b6",
  null
  
)

export default component.exports